import React, { useEffect } from "react";
import { Collapse, Form, Row, Col, Select, Input, Space, Button, DatePicker } from "antd";
// import { RootStateOrAny, useSelector } from "react-redux";
import moment from "moment";
import { FormFieldValue } from "../../lib/interfaces/FormFieldValue";
import { displayFormat } from "../../lib/utils/formatDate";
import { AnyObject } from "../../lib/interfaces/AnyObject";

const { Panel } = Collapse;
const { Option } = Select;

interface IProps {
  advancedSearchForm: any;
  advancedSearchFormValues: FormFieldValue[] | undefined;
  dicCurrencies: any[];
  offerList: AnyObject[];
  dicRoutingOrdersStatuses: any[];
  loadRoutingOrdersList: any;
  initialStateFilters: AnyObject;
  setFilters: any;
}

// interface IProps {
//   handlePageableSearch: (values: FormFieldValue[]) => void;
//   setAccountListPage: (page: number) => void;
//   advancedSearchFormValues: FormFieldValue[];
//   setAdvancedSearchFormValues: React.Dispatch<React.SetStateAction<FormFieldValue[] | undefined>>;
//   setIsPageableSearch: React.Dispatch<React.SetStateAction<boolean>>;
//   isPageableSearch: boolean;
//   setSearchByNameFields: React.Dispatch<React.SetStateAction<FormFieldValue[] | undefined>>;
//   searchByNameForm: any;
//   advancedSearchForm: any;
// }

export function SearchFilterRoutingOrders({
  initialStateFilters,
  advancedSearchForm,
  advancedSearchFormValues,
  dicCurrencies,
  offerList,
  dicRoutingOrdersStatuses,
  loadRoutingOrdersList,
  setFilters,
}: IProps) {
  const onReset = () => {
    advancedSearchForm.resetFields();
    setFilters((prev) => {
      return { ...initialStateFilters, size: prev.size };
    });
    // setAccountListPage(1);
    // setAdvancedSearchFormValues(undefined);
    // setIsPageableSearch(false);
  };

  const onFinish = (attrs) => {
    console.log("onFinish", attrs);
    setFilters((prev) => {
      return { ...prev, page: initialStateFilters.page, ...attrs };
    });
    // loadRoutingOrdersList(attrs)
  };

  return (
    <Collapse expandIconPosition="right" defaultActiveKey={0}>
      <Panel header="Расширенный поиск" key="1">
        <Form
          style={{ marginTop: 20 }}
          form={advancedSearchForm}
          wrapperCol={{ span: 19 }}
          fields={advancedSearchFormValues}
          onFinish={onFinish}
          onReset={onReset}
          labelAlign="left"
          initialValues={initialStateFilters}
        >
          <Row gutter={50} justify="center">
            <Col span={11}>
              <Form.Item name="routingOrder" label="Номер заказа" labelCol={{ span: 6 }}>
                <Input allowClear placeholder="Введите номер" />
              </Form.Item>
              <Form.Item name="offeringId" label="Продукт" labelCol={{ span: 6 }}>
                <Select allowClear placeholder="Введите продукт" mode="multiple">
                  {Array.isArray(offerList) &&
                    offerList.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.name}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
              <Form.Item name="orderStatus" label="Статус заказа" labelCol={{ span: 6 }}>
                <Select allowClear placeholder="Введите статус" mode="multiple">
                  {dicRoutingOrdersStatuses?.map((item) => (
                    <Option key={item.id} value={item.id}>
                      {item.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={11}>
              <Form.Item name="destinationName" label="Направление" labelCol={{ span: 7 }}>
                <Input allowClear placeholder="Введите направление" />
              </Form.Item>
              <Row style={{ display: "flex" }}>
                <Col span={7}>
                  <span className="routingOrder-mandatory">Период</span>
                </Col>
                <Col span={17} style={{ display: "flex", justifyContent: "space-between" }}>
                  <Form.Item style={{ width: "100%" }} name="fromDate" required>
                    <DatePicker
                      allowClear={false}
                      format={displayFormat}
                      disabledDate={(current) => {
                        if (current.isAfter(advancedSearchForm.getFieldValue("toDate"), "day"))
                          return true;
                        return false;
                      }}
                    />
                  </Form.Item>
                  <span style={{ fontWeight: "bold" }}>-</span>
                  <Form.Item
                    style={{ width: "100%", justifyContent: "flex-end" }}
                    name="toDate"
                    required
                  >
                    <DatePicker
                      allowClear={false}
                      format={displayFormat}
                      disabledDate={(current) => {
                        if (current.isBefore(advancedSearchForm.getFieldValue("fromDate"), "day"))
                          return true;
                        return false;
                      }}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Form.Item
                name="currencyId"
                label="Валюта отображения"
                labelCol={{ span: 7 }}
                rules={[{ required: true, message: "Необходимо выбрать валюту" }]}
              >
                <Select allowClear placeholder="Выберите валюту">
                  {dicCurrencies?.map((item) => (
                    <Option key={item.id} value={item.id}>
                      {item.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row justify="end">
            <Space>
              <Form.Item>
                <Button htmlType="reset">Сброс параметров</Button>
              </Form.Item>
              <Form.Item>
                <Button type="primary" htmlType="submit">
                  Применить
                </Button>
              </Form.Item>
            </Space>
          </Row>
        </Form>
      </Panel>
    </Collapse>
  );
}
